<template>
  <div class="section-nucleo-icons">
    <div class="container">
      <div class="row sectionBox">
        <div class="col-lg-6 col-md-12">
          <h3 class="title">One API - All Events</h3>

          <h4 class="description">
            Want to aggregate Crowdify data with your own? Simply integrate the API snippet below and you're good to go!
          </h4>
        </div>
        <pre class="language-curl numbered" style="margin:20px">
          <code class="language-curl">curl 'https://api.crowdify.io/v1/events?lat=<span class="value-css">53.5586941</span>&lng=<span class="value-css">9.7877397</span>&radius=<span class="value-css">20000</span>&start=<span class="value-css">2020-03-01</span>&end=<span class="value-css">2020-03-31</span>' \
            -X GET \
            -H 'x-api-key: <span class="apikey">YOUR API KEY GOES IN HERE'</span>
          </code>
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
import PrismEditor from "vue-prism-editor";
export default {
  data() {
    return {
      code: "https://api.crowdify.io/v1/events?lat=53.5586941&lng=9.7877397&radius=20000&start=2020-03-01&end=2020-03-31",
      lineNumbers: true
    };
  },
  components: {
    PrismEditor
  }
}
</script>
<style scoped>
.my-editor {
  height: 300px;
}

.value-css{
    color: #f5d67b;
}
.apikey {
    color: #72e0d1;
}
.sectionBox{
  background: rgb(242, 242, 242);
  border-radius: 0.8em;
}


</style>
